<template>
  <div class="all_part">
    <!-- <div>
      <titleBlock_computer></titleBlock_computer>   
    </div> -->
    <div class="header">
      <div class="header_left" @click="Back_menu">
        <img src="../assets/mine1.png" alt="">
      </div>

      <div style="width: 18%;display:flex;justify-content: center;">
      <div class="header_Right">
        <img src="../assets/xiaoxi.png" alt="">
        <!-- <div class="header_RightIcon">2</div> -->
      </div>
      </div>

    </div>
    <div class="newsBodyBox" v-for="(item,index) in newsList">
        <div class="newsTitle">
        <div>您关注的<span :class="index==0?'newsTitleRed':''">{{item.client}}/{{item.order_no}}</span>   状态变更为：
            <span :class="index==0?'newsTitleRed':''" v-if="item.list.length>1">状态已变更</span>
            <span :class="index==0?'newsTitleRed':''" v-else>{{item.order_status}}</span>
        </div>
        <div>{{item.edit_time}}</div>
        </div>
        <div class="table">
      <div>
        <el-table
            border
          :data="item.list"
          style="width: 100%"
          height="100%"
          :row-style="{ height: '70px' }"
        >
          <el-table-column prop="add_time" label="建立日期" width="137">
          </el-table-column>
          <el-table-column prop="client" label="客户" width="106">
          </el-table-column>
          <el-table-column prop="business_name" label="业务人员" width="89">
          </el-table-column>
          <el-table-column prop="order_no" label="订单号" width="111">
          </el-table-column>
          <el-table-column prop="client_order_no" label="客户订单号" width="111">
          </el-table-column>
          <el-table-column prop="newItemNo" label="新料号" width="126">
          </el-table-column>
          <el-table-column prop="clientNewItemNo" label="客户料号" width="143">
          </el-table-column>
          <el-table-column prop="oldMaterialNo" label="旧料号" width="129">
          </el-table-column>
          <el-table-column prop="num" label="订单数量" width="96">
          </el-table-column>
          <el-table-column
              prop="arrival_date"
              label="需求到货日期"
              width="127"
          >
          </el-table-column>
          <el-table-column prop="arrive_date" label="到货日期" width="125">
          </el-table-column>
          <el-table-column prop="purchase_no" label="采购单号" width="140">
          </el-table-column>
          <el-table-column prop="order_status" label="订单状态" width="147">
          </el-table-column>
          <el-table-column prop="remark" label="订单备注" width="130">
          </el-table-column>
          <el-table-column prop="stock_status" label="接单库存状态" width="163">
          </el-table-column>
        </el-table>
      </div>
    </div>

    </div>
    
    <div class="block">
      <el-pagination
        background
        :page-sizes="[20]"
        layout="prev, pager, next"
        :total="total"
        :hide-on-single-page="true"
        @current-change="reflash"
      >
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";
export default {
  name: "Main_menuComputer",
  data() {
    return {
      page: "",
      user_leave: {},
      newsList:[],
      total: 0
    };
  },
  mounted() {
    this.getMessageList()
    this.getUser();
  },

  methods: {
     reflash(val) {
      this.page = val;
      this.getMessageList();
    },
    //获取未读消息
    getMessageList() {
      let user = JSON.parse(sessionStorage.getItem('user'));
       this.axios
        .get(
          httpUrl +
            `/api/index/orderMailList?user_id=${user.id}&page=${this.page}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            var arr = response.data.data.data;
            this.newsList = arr;
            this.total = response.data.data.total;
          }else {
            this.newsList = [];
            this.total = 0;
            this.$message(response.data.message);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    Back_menu() {
      this.$router.push({
        name: "Main_menuComputer",
      });
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
  },
};
</script>

<style>
</style>
<style scoped>
.newsBodyBox {
    
width: 98%;
margin: 20px auto;
margin-top: 20rpx;
}
.newsTitle {
    font-size: 15px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 30px;
color: #333333;
display: flex;
justify-content: space-between;
margin-bottom: 20px;

}
.newsTitleRed {
    color:#FF1414;
}
.homeback {
  z-index: -1;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 65%;
}

.bottomsDiv {
  width: 100%;
}

.bottomsDiv_top {
  height: 12px;
  background-color: #358FE5;
}

.bottomsDiv_div {
  width: 100%;
  height: 227px;
  background: #004b43;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.bottomsDiv_div_div {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  font-size: 14px;
  line-height: 24px;
  color: #94c2a2;
  text-align: center;
}

.bottomsDiv_div img {
  width: 140px;
  margin-bottom: 20px;
}

.content_header {
  margin-top: -10px;
  height: 50px;
  width: 100%;
  background-color: #F2F2F2;
  padding: 0 240px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #666666;
}

.header_img {
  width: 100%;
}

.header_img img {
  width: 100%;
  height: 300px;
}
.header {
  background-color: #FFFFFF;
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header_left {
  width: 20%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.header_left img {
  width: 180px;
}

.header_Right {
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 27px;
}

.header_RightIcon {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 20px;
    height: 20px;
    background: #FF1414;
    border-radius: 50%;
    opacity: 1;
    color: #fff;
    line-height: 20px;
}

.header_Right img {
  width: 20px;
  height: 20px;
}


/* .header_right {
  display: flex;
  flex-direction: row;
  align-items: center;
} */

/* .header_right_index {
  width: 122px;
  height: 43px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #18a575;
  border-radius: 21.5px;
  font-size: 22px;
  line-height: 22px;
  color: #ffffff;
  margin-right: 30px;
}

.header_right_indexs {
  font-size: 22px;
  line-height: 22px;
  color: #666666;
  margin-right: 24px;
  border: none;
  text-decoration: none;
} */


.all_part {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  position: relative;
  justify-content: center;
  display: flex;
  width: 100%;
  overflow: hidden;
  flex: 1;
  padding-top: 150px;
  box-sizing: border-box;
  //height: 70%;
}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.button {
  flex-direction: column;
  display: flex;
  align-items: center;
}

.button img {
  width: 110px;
}

.button span {
  font-weight: 600;
  color: #18a575;
  font-size: 20px;
  margin-top: 10px;
}

.Copyright_information {
  margin-bottom: 15px;
}
</style>
